<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码">
              <global-select
                :value.sync="queryParams.itemIdList"
                selectType="selectMultipleSearch"
                requestApi="/mdm/mdmItemSystemItem/itemCodeBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                searchParam="itemCode"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料类别">
              <a-tree-select
                :dropdown-style="{
                  maxHeight: '50vh'
                }"
                v-model="queryParams.categoryIdList"
                :tree-data="treeData"
                :max-tag-count="1"
                :replaceFields="{children: 'child', title: 'name', key: 'segment', value: 'id' }"
                tree-checkable
                allow-clear
                tree-node-filter-prop="title"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiScpScSafetyStockFactorNewExport" ref="download" />
      <a-button @click="$refs.safetyStockCoefficientRerun.show()" type="primary" v-hasPermi="['scp:scpScSafetyStockFactor:recalculate']">重算安全库存系数</a-button>
      <a-button @click="handleExport" v-hasPermi="['scp:scpScSafetyStockFactor:export']">导出</a-button>
      <a-button @click="importExcelHandleOpen" v-hasPermi="['scp:scpScSafetyStockFactor:import']">导入</a-button>
      <a-button @click="handleDeleteAll" v-hasPermi="['scp:scpScSafetyStockFactor:removeAll']">删除所有记录</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 2200 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.SAFETY_STOCK_COEFFICIENT_LIST, // 表格方案配置唯一值
              }"
        >
          <span slot="differenceRatioTitle" class="align-center">平均加权差异率(%)&nbsp;
            <a-popover>
              <template slot="content">
                <p>SKU最近30天的平均加权差异率水平=过去30 天占品类需求占比（实际成品工单的SKU理论用量÷品类理论用量）×（ 过去30 天实际成品工单的理论用量/ 指定版本计划近30 天的计划量计算理论消耗量−1</p>
              </template>
              <span><a-icon type="info-circle" /></span>
            </a-popover>
          </span>
          <span v-for="item in wList" :key="item" :slot="`${item}Title`">
            <i class="toRequired">*</i>{{ item }}
          </span>
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text, record }">
            <div :key="item.dataIndex">
              <span v-if="item.dataIndex === 'operation'">
                <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['scp:scpScSafetyStockFactor:edit']">编辑</a>
                <a v-if="!isEdit || currentId !== record.id" @click="handleDelete(record)" v-hasPermi="['scp:scpScSafetyStockFactor:remove']" class="ml10">删除</a>
                <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
                <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
              </span>
              <span v-else-if="item.type === 'inputNumber'">
                <span v-if="!isEdit || currentId !== record.id">{{ record[item.dataIndex] }}</span>
                <a-input-number v-if="isEdit && currentId === record.id" v-model="record[item.dataIndex]" :min="0" :parser="value =>value.replace(/^\D*(\d*(?:\.\d{0,5})?).*$/g,'$1')" size="small" />
              </span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
        <!-- 上传文件 -->
        <a-modal
          :title="upload.title"
          :visible="excelVisible"
          @ok="importExcelHandleCancel"
          @cancel="importExcelHandleCancel"
        >
          <a-upload-dragger
            name="file"
            accept=".xlsx, .xls"
            :multiple="true"
            :headers="upload.headers"
            :action="upload.url + '?updateSupport=' + upload.updateSupport"
            @change="importExcelHandleChange"
          >
            <p class="ant-upload-drag-icon">
              <a-icon type="inbox" />
            </p>
            <p class="ant-upload-text">
              请将文件拖拽到此处上传
            </p>
            <p class="ant-upload-hint">
              支持单个或批量上传，也可以点击后选择文件上传
            </p>
          </a-upload-dragger>
        </a-modal>
        <safety-stock-coefficient-rerun ref="safetyStockCoefficientRerun" @handle-success="handleOk" />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import {
  apiScpScSafetyStockFactor,
  apiScpScSafetyStockFactorDel,
  apiScpScSafetyStockFactorList,
  apiScpMrpCategoryCodeCategoryBox,
  apiScpScSafetyStockFactorNewExport,
  apiScpScSafetyStockFactorRemoveAll
} from '@/api/scp/safety-stock/safety-stock-coefficient'
import { generateLsTableResData } from '@/utils/util.js';
import Cookies from 'js-cookie';
import SafetyStockCoefficientRerun from './components/safety-stock-coefficient-rerun'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'Safety-stock-coefficient', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DownloadModal,
    SafetyStockCoefficientRerun
  },
  data () {
    const token = (process.env.NODE_ENV === "development" || localStorage.getItem('isFromSystemLogin') === 'true') ? localStorage.getItem('token') : Cookies.get('Admin-Token')
    const Authorization = token ? 'Bearer ' + token : undefined;
    return {
      apiScpScSafetyStockFactorNewExport,
      // 导入excel
      excelVisible: false,
      // 用户导入参数
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '导入Excel',
        // 是否禁用上传
        isUploading: false,
        // 是否更新已经存在的用户数据
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: Authorization },
        // 上传的地址
        url: process.env.VUE_APP_API_BASE_URL + '/scp/scpScSafetyStockFactor/import'
      },
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpScSafetyStockFactorList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        categoryIdList: undefined,
        itemIdList: undefined
      },
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          stickyFixed: 'left'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          align: 'center',
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specification',
          ellipsis: true,
          align: 'center'
        },
        {
          // title: '平均加权差异率',
          customTitle: '平均加权差异率(%)',
          dataIndex: 'differenceRatio',
          scopedSlots: { customRender: 'differenceRatio', title: "differenceRatioTitle" },
          align: 'center',
          width: 150
        },
        {
          // title: 'W1',
          customTitle: 'W1',
          dataIndex: 'quantity01',
          scopedSlots: { customRender: 'quantity01', title: "W1Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W2',
          customTitle: 'W2',
          dataIndex: 'quantity02',
          scopedSlots: { customRender: 'quantity02', title: "W2Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W3',
          customTitle: 'W3',
          dataIndex: 'quantity03',
          scopedSlots: { customRender: 'quantity03', title: "W3Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W4',
          customTitle: 'W4',
          dataIndex: 'quantity04',
          scopedSlots: { customRender: 'quantity04', title: "W4Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W5',
          customTitle: 'W5',
          dataIndex: 'quantity05',
          scopedSlots: { customRender: 'quantity05', title: "W5Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W6',
          customTitle: 'W6',
          dataIndex: 'quantity06',
          scopedSlots: { customRender: 'quantity06', title: "W6Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W7',
          customTitle: 'W7',
          dataIndex: 'quantity07',
          scopedSlots: { customRender: 'quantity07', title: "W7Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W8',
          customTitle: 'W8',
          dataIndex: 'quantity08',
          scopedSlots: { customRender: 'quantity08', title: "W8Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          // title: 'W9',
          customTitle: 'W9',
          dataIndex: 'quantity09',
          scopedSlots: { customRender: 'quantity09', title: "W9Title" },
          align: 'center',
          type: "inputNumber"
        },
        {
          title: '一级分类',
          dataIndex: 'name1',
          align: 'center',
          ellipsis: true
        },
        {
          title: '二级分类',
          dataIndex: 'name2',
          align: 'center',
          ellipsis: true
        },
        {
          title: '三级分类',
          dataIndex: 'name3',
          align: 'center',
          ellipsis: true
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      treeData: [], // 物料类别
      wList: ["W1", "W2", "W3", "W4", "W5", "W6", "W7", "W8", "W9"]
    }
  },
  computed: {
    ...mapState({
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  created () {
    this.getSearchAllScheme()
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch () {
      this.isEdit = false;
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    // 删除所有记录
    handleDeleteAll () {
      const self = this
      this.$confirm({
        title: '警告',
        content: `你确定要删除所有记录吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpScSafetyStockFactorRemoveAll(self.queryParams).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 行删除
    handleDelete (row) {
      const self = this
      this.$confirm({
        title: '警告',
        content: `你确定要删除这行内容吗?`,
        okText: '删除',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          apiScpScSafetyStockFactorDel(row.id).then((response) => {
            if (response.code === 200) {
              self.$message.success('删除成功!')
              self.onSearch()
            } else {
              self.$message.error(response.msg)
            }
          })
        }
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (record.quantity01 === "" ||
      record.quantity02 === "" ||
      record.quantity03 === "" ||
      record.quantity04 === "" ||
      record.quantity05 === "" ||
      record.quantity06 === "" ||
      record.quantity07 === "" ||
      record.quantity08 === "" ||
      record.quantity09 === "") {
        this.$message.error('必填项不能为空')
        return
      }
      apiScpScSafetyStockFactor(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.isEdit = false
          this.onSearch()
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    // 重算安全库存系数
    handleOk () {
      this.onSearch()
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        categoryIdList: undefined,
        itemIdList: undefined
      }
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导入excel */
    importExcelHandleChange (info) {
      const status = info.file.status
      if (status !== 'uploading') {
      }
      if (status === 'done') {
        this.$message.success(`${info.file.name}: ${info.file.response.msg}`)
      } else if (status === 'error') {
        this.$message.error(`${info.file.name}: ${info.file.response.msg}`)
      }
    },
    /** 导入excel窗体关闭 */
    importExcelHandleCancel (e) {
      this.excelVisible = false
      // 关闭后刷新列表
      this.handleQuery()
    },
    /** 导入excel窗体开启 */
    importExcelHandleOpen (e) {
      this.excelVisible = true
    },
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('scp/scpScSafetyStockFactor/export', {
      //   ...this.queryParams
      // }, `安全库存系数_${new Date().getTime()}.xlsx`)
    },
    // 物料类别
    getSearchAllScheme () {
      apiScpMrpCategoryCodeCategoryBox({ parameterCode: "SCP_ITEM_CATEGORY", parameterLevelCode: "GLOBAL" }).then(res => {
        if (res.data && res.data.length > 0) {
          this.treeData = res.data
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
.ant-input-number {
  width: 100px;
}
</style>
